// extracted by mini-css-extract-plugin
export default {"Navigation":"Navigation_Navigation__83bn0","burger":"Navigation_burger__xokmy","navFooter":"Navigation_navFooter__RcNm0","langButton":"Navigation_langButton__7VFRd"};